import customAxios from "lib/axios";

const BASE_PATH = "/notifications/economic-calendar-events";
const REQUEST_TIMEOUT_MS = 10000;

const normalizeDatetime = (value) =>
  String(value || "").trim().replace("T", " ").slice(0, 19);

export const buildCalendarEventIdentity = (event) =>
  [
    normalizeDatetime(event?.datetime),
    String(event?.currency || "").trim().toUpperCase(),
    Number(event?.impact),
    String(event?.name || "").trim(),
    String(event?.country || "").trim(),
  ].join("|");

export const serializeCalendarEvent = (event) => ({
  datetime: normalizeDatetime(event?.datetime),
  currency: String(event?.currency || "").trim().toUpperCase(),
  impact: Number(event?.impact),
  name: String(event?.name || "").trim(),
  country: String(event?.country || "").trim() || null,
});

export const getCalendarEventSubscriptions = async (date, config = {}) => {
  const { data } = await customAxios.get(BASE_PATH, {
    params: { date },
    timeout: REQUEST_TIMEOUT_MS,
    ...config,
  });
  return Array.isArray(data?.items) ? data.items : [];
};

export const subscribeToCalendarEvent = async (event) => {
  const { data } = await customAxios.post(
    BASE_PATH,
    {
      event: serializeCalendarEvent(event),
    },
    { timeout: REQUEST_TIMEOUT_MS }
  );
  return data?.item;
};

export const unsubscribeFromCalendarEvent = async (eventKey) => {
  await customAxios.delete(`${BASE_PATH}/${encodeURIComponent(eventKey)}`, {
    timeout: REQUEST_TIMEOUT_MS,
  });
};
